import React from 'react';
import { Link } from 'react-router-dom';

/*
    - ihoDesignSystem
*/
import { Alert, Box, Button, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import WalletSVG from '../../../assets/images/finance/wallet.svg';
import ShapeSVG from '../../../assets/images/finance/shape.svg';
import CoinSVG from '../../../assets/images/finance/coin.svg';
import BatterySVG from '../../../assets/images/finance/battery.svg';
import ChevronUpYellowSVG from '../../../assets/images/icons/chevron-up-yellow.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';

/*
    - api
*/
import editWalletRequestAPI from '../../../api/edit/WalletRequest';

const Banner = ({ props, alertProps, reloadFinanceProps }) => {

    /*
        - defaultData
    */
    const type = localStorage.getItem('type');
    const [walletBalance, setWalletBalance] = React.useState('loading');
    const [balance, setBalance] = React.useState('loading');
    const [bankAccount, setBankAccount] = React.useState('empty');
    const [credit, setCredit] = React.useState('3,000,000');
    const [walletParameters, setWalletParameters] = React.useState({
        accountId: {
            value: '',
            color: 'dark'
        },
        price: {
            value: '',
            color: 'dark'
        }
    });
    const [lowCreditError, setLowCreditError] = React.useState(false);

    React.useEffect(() => {
        if (props.walletBalance.status === 200) {
            setWalletBalance(props.walletBalance.data);
        }
        if (props.bankAccount.status === 200 && props.bankAccount.data.length > 0) {
            setBankAccount(props.bankAccount.data);
        }
        if (props.balance.status === 200) {
            setBalance(props.balance.data);
        }
    }, [props]);

    /*
        - walletRequestHandler
    */
    const editWalletRequestHandler = (key, value) => {
        if (key === 'accountId') {
            setWalletParameters({
                ...walletParameters,
                accountId: {
                    value: value,
                    color: 'dark'
                }
            });
        }
        if (key === 'price') {
            setWalletParameters({
                ...walletParameters,
                price: {
                    value: value,
                    color: 'dark'
                }
            });
        }
    }

    /*
        - editWalletRequest
    */
    const editWalletRequest = async () => {
        let parameters = {};
        let isValid = 1;
        if (walletParameters.accountId.value === '') {
            setWalletParameters({
                ...walletParameters,
                accountId: {
                    value: '',
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.AccountId = walletParameters.accountId.value;
            if (walletParameters.price.value === '') {
                parameters.Price = walletBalance.CashBalance;
            } else {
                parameters.Price = walletParameters.price.value * 10;
            }
            let result = await editWalletRequestAPI(parameters);
            if (result === 'success') {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadFinanceProps(Math.floor(Math.random() * 100));
                closeModal('walletRequestModal');
            } else {
                alertProps(['danger', 'خطایی رخ داده است']);
            }
            setWalletParameters({
                ...walletParameters,
                price: {
                    value: '',
                    color: 'dark'
                }
            });
        }
    }

    /*
        - chargeWallet
    */
    const chargeWallet = () => {
        if (credit.replaceAll(',', '') >= 100000) {
            window.location.replace(`/api/mvc/payment/Wallet/GotoParsianIPG/1/${credit.replaceAll(',', '') * 10}`);
        } else {
            setLowCreditError(true);
        }
    }

    /*
        - toggleBox
    */
    const toggleBox = (className) => {
        document.querySelector(`.${className}`).classList.toggle('d-none');
        if (document.querySelector(`.${className}`).classList[2] === undefined) {
            document.querySelector(`.${className}-chevron`).style.rotate = '180deg';
        } else {
            document.querySelector(`.${className}-chevron`).style.rotate = '0deg';
        }
    }

    /*
        - modal
    */
    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    }

    const closeModal = (modal) => {
        if (modal === 'chargeWalletModal') {
            setCredit('3,000,000')
        }
        document.querySelector(`.${modal}`).classList.add('d-none');
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper
                    className={`justify-content-cneter`}>
                    {type === 'B2C' &&
                        <Grid.Item
                            size='col-12'>
                            <Box
                                className={`my-xl mb-0 rounded-lg position-relative`}
                                ms={{
                                    width: '100%',
                                    height: '170px',
                                    backgroundImage: 'linear-gradient(#AC5DD9,#4C0099)',
                                    border: '1px solid #AC5DD9'
                                }}>
                                <Box
                                    className='w-100 h-100 position-absolute'>
                                    <Image
                                        className={`h-100`}
                                        src={ShapeSVG}
                                        alt='shape' />
                                </Box>
                                <Box
                                    className={`position-absolute left-xxl bottom-xl`}
                                    ms={{
                                        width: '200px',
                                        '@media(max-width:576px)': {
                                            width: '160px',
                                            left: '0.75rem'
                                        }
                                    }}>
                                    <Image
                                        className={`h-100`}
                                        src={WalletSVG}
                                        alt='banner-wallet' />
                                </Box>
                                <Box
                                    className={`position-absolute transform-vertical-center right-xxl`}
                                    ms={{
                                        '@media(max-width:576px)': {
                                            right: '0.75rem'
                                        }
                                    }}>
                                    <Box
                                        className={`d-flex align-item-center`} >
                                        <Typography
                                            className='d-block text-white'
                                            ms={{
                                                width: '136px'
                                            }}>
                                            موجودی حساب من
                                        </Typography>
                                        <Box
                                            className={`mx-lg`} />
                                        <Typography
                                            className='d-block text-white'
                                            component='h4'>
                                            {walletBalance !== 'loading' && `${(walletBalance.Balance / 10).toLocaleString()} تومان`}
                                            {walletBalance === 'loading' &&
                                                <Image
                                                    className={`d-inline`}
                                                    src={LoadingCustomSVG}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            }
                                        </Typography>
                                    </Box>
                                    <Box
                                        className={`d-flex align-item-center`}>
                                        <Typography
                                            className='d-block text-white'
                                            ms={{
                                                width: '136px'
                                            }}>
                                            مبلغ قابل برداشت
                                        </Typography>
                                        <Box
                                            className={`mx-lg`} />
                                        <Typography
                                            className='d-block text-white'
                                            component='h4'>
                                            {walletBalance !== 'loading' && `${(Math.floor(walletBalance.CashBalance) / 10).toLocaleString()} تومان`}
                                            {walletBalance === 'loading' &&
                                                <Image
                                                    className={`d-inline`}
                                                    src={LoadingCustomSVG}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            }
                                        </Typography>
                                    </Box>
                                    <Box
                                        className={`my-lg`} />
                                    <Box
                                        className={`d-flex`}>
                                        <Button
                                            onClick={() => openModal('walletRequestModal')}
                                            variant='filled'
                                            color='peace'>
                                            تسویه موجودی
                                        </Button>
                                        <Box
                                            className={`mx-sm`} />
                                        <Button
                                            onClick={() => openModal('chargeWalletModal')}
                                            variant='outlined'
                                            color='peace'>
                                            افزایش موجودی
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                            <Modal
                                className={`walletRequestModal`}>
                                <Modal.Wrapper
                                    size='xs'
                                    ms={{
                                        '@media(max-width:576px)': {
                                            width: '100% !important'
                                        }
                                    }}>
                                    <Modal.Header
                                        className={`border-solid-bottom border-light`}>
                                        تسویه موجودی
                                        <Box />
                                    </Modal.Header>
                                    <Box
                                        className={`my-md mt-0 `} />
                                    <Typography
                                        className={`px-lg text-justify`}>
                                        مبلغ قابل برداشت کیف پول شما <Typography
                                            component='strong'>
                                            {walletBalance !== 'loading' && `${(Math.floor(walletBalance.CashBalance) / 10).toLocaleString()} تومان`}
                                            {walletBalance === 'loading' &&
                                                <Image
                                                    className={`d-inline`}
                                                    src={LoadingCustomSVG}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            }
                                        </Typography> است. در صورت تمایل این موجودی به شماره حسابی که از لیست زیر انتخاب می کنید، واریز خواهد شد.
                                    </Typography>
                                    <Grid>
                                        <Grid.Wrapper
                                            className={`px-sm`}>
                                            <Grid.Item
                                                size='col-12'>
                                                <Select
                                                    onChange={(event) => editWalletRequestHandler('accountId', event)}
                                                    color={walletParameters.accountId.color}
                                                    placeholder='انتخاب حساب'>
                                                    {bankAccount !== 'empty' && bankAccount.map((obj, index) => {
                                                        return (
                                                            <Select.Item
                                                                key={index}
                                                                value={obj.Id}>
                                                                {obj.CardNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')}
                                                            </Select.Item>
                                                        )
                                                    })}
                                                </Select>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-12'>
                                                <TextField
                                                    onChange={(event) => editWalletRequestHandler('price', event)}
                                                    color={walletParameters.price.color}
                                                    placeholder='مبلغ دلخواه'
                                                    value={walletParameters.price.value} />
                                            </Grid.Item>
                                            <Grid.Item
                                                className={`d-flex`}
                                                size='col-8 col-md-6'>
                                                {walletBalance.CashBalance > 0 &&
                                                    <Button
                                                        onClick={editWalletRequest}
                                                        variant='filled'
                                                        color='primary'>
                                                        تسویه موجودی
                                                    </Button>
                                                }
                                                {walletBalance.CashBalance > 0 &&
                                                    <Box
                                                        className={`mx-sm`} />
                                                }
                                                {walletBalance.CashBalance === 0 &&
                                                    <Button
                                                        variant='filled'
                                                        color='primary'
                                                        disabled
                                                        ms={{
                                                            background: 'var(--gray-light) !important'
                                                        }}>
                                                        غیر فعال
                                                    </Button>
                                                }
                                                {walletBalance.CashBalance === 0 &&
                                                    <Box
                                                        className={`mx-sm`} />
                                                }
                                                <Button
                                                    onClick={() => closeModal('walletRequestModal')}
                                                    variant='outlined'
                                                    color='primary'>
                                                    انصراف
                                                </Button>
                                            </Grid.Item>
                                        </Grid.Wrapper>
                                    </Grid>
                                </Modal.Wrapper>
                            </Modal>
                            <Modal
                                className={`chargeWalletModal`}>
                                <Modal.Wrapper
                                    size='xs'
                                    ms={{
                                        '@media(max-width:576px)': {
                                            width: 'calc(100% - 12px) !important'
                                        }
                                    }}>
                                    <Modal.Header
                                        className={`my-md mt-0 border-solid-bottom border-light`}>
                                        افزایش موجودی
                                        <Box />
                                    </Modal.Header>
                                    <Typography
                                        className={`px-lg text-justify`}>
                                        موجودی فعلی کیف پول شما <Typography
                                            component='strong'>
                                            {walletBalance !== 'loading' && (Math.floor(walletBalance.CashBalance) / 10).toLocaleString()} تومان
                                            {walletBalance === 'loading' &&
                                                <Image
                                                    className={`d-inline`}
                                                    src={LoadingCustomSVG}
                                                    ms={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }} />
                                            }
                                        </Typography> است. در صورت تمایل می توانید از لیست زیر اقدام به افزایش موجودی خود نمایید.
                                    </Typography>
                                    <Grid>
                                        <Grid.Wrapper>
                                            <Grid.Item
                                                size='col-4'>
                                                <Button
                                                    onClick={() => setCredit('3,000,000')}
                                                    className={`w-100`}
                                                    variant='outlined'
                                                    color='primary'
                                                    size='sm'
                                                    ms={{
                                                        fontSize: '10px'
                                                    }}>
                                                    3,000,000
                                                    تومان
                                                </Button>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-4'>
                                                <Button
                                                    onClick={() => setCredit('5,000,000')}
                                                    className={`w-100`}
                                                    variant='outlined'
                                                    color='primary'
                                                    size='sm'
                                                    ms={{
                                                        fontSize: '10px'
                                                    }}>
                                                    5,000,000
                                                    تومان
                                                </Button>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-4'>
                                                <Button
                                                    onClick={() => setCredit('10,000,000')}
                                                    className={`w-100`}
                                                    variant='outlined'
                                                    color='primary'
                                                    size='sm'
                                                    ms={{
                                                        fontSize: '10px'
                                                    }}>
                                                    10,000,000
                                                    تومان
                                                </Button>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-12'>
                                                {lowCreditError &&
                                                    <Alert
                                                        className={`position-static`}
                                                        color='danger'
                                                        ms={{
                                                            boxShadow: 'none'
                                                        }}>
                                                        حداقل مبلغ شارژ کیف پول 100,000 تومان است.
                                                    </Alert>
                                                }
                                                <TextField
                                                    onChange={setCredit}
                                                    variant='filled'
                                                    label='سایر مبالغ (تومان)'
                                                    placeholder='سایر مبالغ (تومان)'
                                                    hint='حداقل مبلغ 100,0000 تومان می باشد'
                                                    value={credit} />
                                            </Grid.Item>
                                            <Grid.Item
                                                className={`d-flex`}
                                                size='col-8 col-md-6'>
                                                <Button
                                                    onClick={chargeWallet}
                                                    variant='filled'
                                                    color='primary'>
                                                    افزایش موجودی
                                                </Button>
                                                <Box
                                                    className={`mx-sm`} />
                                                <Button
                                                    onClick={() => closeModal('chargeWalletModal')}
                                                    variant='outlined'
                                                    color='primary'>
                                                    انصراف
                                                </Button>
                                            </Grid.Item>
                                        </Grid.Wrapper>
                                    </Grid>
                                </Modal.Wrapper>
                            </Modal>
                        </Grid.Item>
                    }
                    {type === 'B2B' &&
                        <React.Fragment>
                            <Grid.Item
                                size='col-12 lg-4 md-6'>
                                <Box
                                    className={`rounded-lg`}
                                    ms={{
                                        width: '100%',
                                        backgroundImage: 'linear-gradient(#06C270,#05A660)'
                                    }}>
                                    <Box
                                        className={`d-flex justify-content-between align-item-center px-xxl py-lg`}>
                                        <Box>
                                            <Typography
                                                className={`d-block text-center text-white`}>
                                                سقف اعتبار
                                            </Typography>
                                            <Typography
                                                className={`d-block text-bold text-center text-white`}>
                                                {balance !== 'loading' && `${(Math.floor(balance.credit.creditLimit) / 10).toLocaleString()} تومان`}
                                                {balance === 'loading' &&
                                                    <Image
                                                        className={`d-inline`}
                                                        src={LoadingCustomSVG}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                }
                                            </Typography>
                                        </Box>
                                        <Image
                                            onClick={() => toggleBox('first')}
                                            className={`first-chevron pointer`}
                                            src={ChevronUpYellowSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        <Image
                                            src={CoinSVG}
                                            ms={{
                                                width: '62px',
                                                height: '62px'
                                            }} />
                                    </Box>
                                    <Box
                                        className={`mx-auto divider-horizontal divider-light`}
                                        ms={{
                                            width: '85%',
                                            opacity: '0.5'
                                        }} />
                                    <Box
                                        className={`first d-none`}
                                        ms={{
                                            height: '92px'
                                        }}>
                                        <Box
                                            className={`d-flex justify-content-between align-item-center px-xxl py-lg`}>
                                            <Box>
                                                <Typography
                                                    className={`d-block text-center text-white`}
                                                    component='small'>
                                                    موجودی اعتبار
                                                </Typography>
                                                <Typography
                                                    className={`d-block text-bold text-center text-white`}
                                                    component='small'>
                                                    {balance !== 'loading' && `${(Math.floor(balance.credit.creditBalance) / 10).toLocaleString()} تومان`}
                                                    {balance === 'loading' &&
                                                        <Image
                                                            className={`d-inline`}
                                                            src={LoadingCustomSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                    }
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block text-center text-white`}
                                                    component='small'>
                                                    بدهی قابل پرداخت
                                                </Typography>
                                                <Typography
                                                    className={`d-block text-bold text-center text-white`}
                                                    component='small'>
                                                    {balance !== 'loading' && `${(Math.floor(balance.credit.creditDebt) / 10).toLocaleString()} تومان`}
                                                    {balance === 'loading' &&
                                                        <Image
                                                            className={`d-inline`}
                                                            src={LoadingCustomSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                    }
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box
                                        className={`w-100 p-md border-solid border-light rounded-md rounded-top-left-0 rounded-top-right-0`}
                                        ms={{
                                            backgroundColor: 'var(--white)',
                                            '@media(max-width:576px)': {
                                                right: '0.75rem'
                                            }
                                        }}>
                                        <Link
                                            to='/finance/settlement'>
                                            <Typography
                                                className={`w-100 text-center text-primary border-solid border-primary rounded-sm`}
                                                ms={{
                                                    height: '32px',
                                                    lineHeight: '32px',
                                                    transition: '0.5s',
                                                    '&:hover': {
                                                        backgroundColor: 'var(--blue-ultra-light)'
                                                    }
                                                }}>
                                                تسویه اعتبار از طریق کیف پول
                                            </Typography>
                                        </Link>
                                    </Box>
                                </Box>
                            </Grid.Item>
                            <Grid.Item
                                size='col-12 lg-4 md-6'>
                                <Box
                                    className={`rounded-lg position-relative`}
                                    ms={{
                                        width: '100%',
                                        backgroundImage: 'linear-gradient(#0A6ADA,#004BC7)'
                                    }}>
                                    <Box
                                        className={`d-flex justify-content-between align-item-center px-xxl py-lg`}>
                                        <Box>
                                            <Typography
                                                className={`d-block text-center text-white`}>
                                                موجودی کیف پول
                                            </Typography>
                                            <Typography
                                                className={`d-block text-bold text-center text-white`}>
                                                {balance !== 'loading' && `${(Math.floor(balance.wallet.walletBalance) / 10).toLocaleString()} تومان`}
                                                {balance === 'loading' &&
                                                    <Image
                                                        className={`d-inline`}
                                                        src={LoadingCustomSVG}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                }
                                            </Typography>
                                        </Box>
                                        <Image
                                            onClick={() => toggleBox('second')}
                                            className={`second-chevron pointer`}
                                            src={ChevronUpYellowSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        <Image
                                            src={WalletSVG}
                                            ms={{
                                                width: '62px',
                                                height: '62px'
                                            }} />
                                    </Box>
                                    <Box
                                        className={`mx-auto divider-horizontal divider-light`}
                                        ms={{
                                            width: '85%',
                                            opacity: '0.5'
                                        }} />
                                    <Box
                                        className={`second d-none`}
                                        ms={{
                                            height: '92px'
                                        }}>
                                        <Box
                                            className={`d-flex justify-content-between align-item-center px-xxl py-lg`}>
                                            <Box>
                                                <Typography
                                                    className={`d-block text-center text-white`}
                                                    component='small'>
                                                    غیرقابل برداشت
                                                </Typography>
                                                <Typography
                                                    className={`d-block text-center text-white`}
                                                    component='small'>
                                                    (ویژه کاربران IHO)
                                                </Typography>
                                                <Typography
                                                    className={`d-block text-bold text-center text-white`}
                                                    component='small'>
                                                    {balance !== 'loading' && `${(Math.floor(balance.wallet.blockBalance) / 10).toLocaleString()} تومان`}
                                                    {balance === 'loading' &&
                                                        <Image
                                                            className={`d-inline`}
                                                            src={LoadingCustomSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                    }
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block text-center text-white`}
                                                    component='small'>
                                                    قابل برداشت
                                                </Typography>
                                                <Typography
                                                    className={`d-block text-bold text-center text-white`}
                                                    component='small'>
                                                    {balance !== 'loading' && `${(Math.floor(balance.wallet.cashBalance) / 10).toLocaleString()} تومان`}
                                                    {balance === 'loading' &&
                                                        <Image
                                                            className={`d-inline`}
                                                            src={LoadingCustomSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                    }
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box
                                        className={`d-flex w-100 p-md border-solid border-light rounded-md rounded-top-left-0 rounded-top-right-0`}
                                        ms={{
                                            gap: '8px',
                                            backgroundColor: 'var(--white)',
                                            '@media(max-width:576px)': {
                                                right: '0.75rem'
                                            }
                                        }}>
                                        <Button
                                            onClick={() => openModal('editWalletRequestModal')}
                                            className={`w-100`}
                                            color='primary'
                                            size='sm'>
                                            تسویه موجودی
                                        </Button>
                                        <Button
                                            onClick={() => openModal('chargeWalletModal')}
                                            className={`w-100`}
                                            variant='outlined'
                                            color='primary'
                                            size='sm'>
                                            افزایش موجودی
                                        </Button>
                                    </Box>
                                </Box>
                                <Modal
                                    className={`editWalletRequestModal`}>
                                    <Modal.Wrapper
                                        size='xs'
                                        ms={{
                                            '@media(max-width:576px)': {
                                                width: '100% !important'
                                            }
                                        }}>
                                        <Modal.Header
                                            className={`border-solid-bottom border-light`}>
                                            تسویه موجودی
                                            <Box />
                                        </Modal.Header>
                                        <Box
                                            className={`my-md mt-0 `} />
                                        <Typography
                                            className={`px-lg text-justify`}>
                                            مبلغ قابل برداشت کیف پول شما <Typography
                                                component='strong'>
                                                {balance !== 'loading' && `${(Math.floor(balance.wallet.cashBalance) / 10).toLocaleString()} تومان`}
                                                {balance === 'loading' &&
                                                    <Image
                                                        className={`d-inline`}
                                                        src={LoadingCustomSVG}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                }
                                            </Typography> است. در صورت تمایل این موجودی به شماره حسابی که از لیست زیر انتخاب می کنید، واریز خواهد شد.
                                        </Typography>
                                        <Grid>
                                            <Grid.Wrapper
                                                className={`px-sm`}>
                                                <Grid.Item
                                                    size='col-12'>
                                                    <Select
                                                        onChange={(event) => editWalletRequestHandler('accountId', event)}
                                                        color={walletParameters.accountId.color}
                                                        placeholder='انتخاب حساب'>
                                                        {bankAccount !== 'empty' && bankAccount.map((obj, index) => {
                                                            return (
                                                                <Select.Item
                                                                    key={index}
                                                                    value={obj.Id}>
                                                                    {obj.CardNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')}
                                                                </Select.Item>
                                                            )
                                                        })}
                                                    </Select>
                                                </Grid.Item>
                                                <Grid.Item
                                                    size='col-12'>
                                                    <TextField
                                                        onChange={(event) => editWalletRequestHandler('price', event)}
                                                        color={walletParameters.price.color}
                                                        placeholder='مبلغ دلخواه'
                                                        value={walletParameters.price.value} />
                                                </Grid.Item>
                                                <Grid.Item
                                                    className={`d-flex`}
                                                    size='col-8 col-md-6'>
                                                    {balance !== 'loading' && balance.wallet.cashBalance > 0 &&
                                                        <Button
                                                            onClick={editWalletRequest}
                                                            variant='filled'
                                                            color='primary'>
                                                            تسویه موجودی
                                                        </Button>
                                                    }
                                                    {balance !== 'loading' && balance.wallet.cashBalance > 0 &&
                                                        <Box
                                                            className={`mx-sm`} />
                                                    }
                                                    {balance !== 'loading' && balance.wallet.cashBalance === 0 &&
                                                        <Button
                                                            variant='filled'
                                                            color='primary'
                                                            disabled
                                                            ms={{
                                                                background: 'var(--gray-light) !important'
                                                            }}>
                                                            غیر فعال
                                                        </Button>
                                                    }
                                                    {balance !== 'loading' && balance.wallet.cashBalance === 0 &&
                                                        <Box
                                                            className={`mx-sm`} />
                                                    }
                                                    <Button
                                                        onClick={() => closeModal('editWalletRequestModal')}
                                                        variant='outlined'
                                                        color='primary'>
                                                        انصراف
                                                    </Button>
                                                </Grid.Item>
                                            </Grid.Wrapper>
                                        </Grid>
                                    </Modal.Wrapper>
                                </Modal>
                                <Modal
                                    className={`chargeWalletModal`}>
                                    <Modal.Wrapper
                                        size='xs'
                                        ms={{
                                            '@media(max-width:576px)': {
                                                width: 'calc(100% - 12px) !important'
                                            }
                                        }}>
                                        <Modal.Header
                                            className={`my-md mt-0 border-solid-bottom border-light`}>
                                            افزایش موجودی
                                            <Box />
                                        </Modal.Header>
                                        <Typography
                                            className={`px-lg text-justify`}>
                                            موجودی فعلی کیف پول شما <Typography
                                                component='strong'>
                                                {balance !== 'loading' && `${(Math.floor(balance.wallet.cashBalance) / 10).toLocaleString()} تومان`}
                                                {balance === 'loading' &&
                                                    <Image
                                                        className={`d-inline`}
                                                        src={LoadingCustomSVG}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                }
                                            </Typography> است. در صورت تمایل می توانید از لیست زیر اقدام به افزایش موجودی خود نمایید.
                                        </Typography>
                                        <Grid>
                                            <Grid.Wrapper>
                                                <Grid.Item
                                                    size='col-4'>
                                                    <Button
                                                        onClick={() => setCredit('3,000,000')}
                                                        className={`w-100`}
                                                        variant='outlined'
                                                        color='primary'
                                                        size='sm'
                                                        ms={{
                                                            fontSize: '10px'
                                                        }}>
                                                        3,000,000
                                                        تومان
                                                    </Button>
                                                </Grid.Item>
                                                <Grid.Item
                                                    size='col-4'>
                                                    <Button
                                                        onClick={() => setCredit('5,000,000')}
                                                        className={`w-100`}
                                                        variant='outlined'
                                                        color='primary'
                                                        size='sm'
                                                        ms={{
                                                            fontSize: '10px'
                                                        }}>
                                                        5,000,000
                                                        تومان
                                                    </Button>
                                                </Grid.Item>
                                                <Grid.Item
                                                    size='col-4'>
                                                    <Button
                                                        onClick={() => setCredit('10,000,000')}
                                                        className={`w-100`}
                                                        variant='outlined'
                                                        color='primary'
                                                        size='sm'
                                                        ms={{
                                                            fontSize: '10px'
                                                        }}>
                                                        10,000,000
                                                        تومان
                                                    </Button>
                                                </Grid.Item>
                                                <Grid.Item
                                                    size='col-12'>
                                                    {lowCreditError &&
                                                        <Alert
                                                            className={`position-static`}
                                                            color='danger'
                                                            ms={{
                                                                boxShadow: 'none'
                                                            }}>
                                                            حداقل مبلغ شارژ کیف پول 100,000 تومان است.
                                                        </Alert>
                                                    }
                                                    <TextField
                                                        onChange={setCredit}
                                                        label='سایر مبالغ (تومان)'
                                                        placeholder='سایر مبالغ (تومان)'
                                                        hint='حداقل مبلغ 100,000 تومان می باشد'
                                                        value={credit} />
                                                </Grid.Item>
                                                <Grid.Item
                                                    className={`d-flex`}
                                                    size='col-8 col-md-6'>
                                                    <Button
                                                        onClick={chargeWallet}
                                                        variant='filled'
                                                        color='primary'>
                                                        افزایش موجودی
                                                    </Button>
                                                    <Box
                                                        className={`mx-sm`} />
                                                    <Button
                                                        onClick={() => closeModal('chargeWalletModal')}
                                                        variant='outlined'
                                                        color='primary'>
                                                        انصراف
                                                    </Button>
                                                </Grid.Item>
                                            </Grid.Wrapper>
                                        </Grid>
                                    </Modal.Wrapper>
                                </Modal>
                            </Grid.Item>
                            <Grid.Item
                                size='col-12 lg-4 md-6'>
                                <Box
                                    className={`rounded-lg`}
                                    ms={{
                                        width: '100%',
                                        backgroundImage: 'linear-gradient(#AC5DD9,#4C0099)'
                                    }}>
                                    <Box
                                        className={`d-flex justify-content-between align-item-center px-xxl py-lg`}>
                                        <Box>
                                            <Typography
                                                className={`d-block text-center text-white`}>
                                                کل شارژ
                                            </Typography>
                                            <Typography
                                                className={`d-block text-bold text-center text-white`}>
                                                {balance !== 'loading' && `${(Math.floor(balance.members.chargedPrice) / 10).toLocaleString()} تومان`}
                                                {balance === 'loading' &&
                                                    <Image
                                                        className={`d-inline`}
                                                        src={LoadingCustomSVG}
                                                        ms={{
                                                            width: '20px',
                                                            height: '20px'
                                                        }} />
                                                }
                                            </Typography>
                                        </Box>
                                        <Image
                                            onClick={() => toggleBox('third')}
                                            className={`third-chevron pointer`}
                                            src={ChevronUpYellowSVG}
                                            ms={{
                                                width: '20px',
                                                height: '20px'
                                            }} />
                                        <Image
                                            src={BatterySVG}
                                            ms={{
                                                width: '62px',
                                                height: '62px'
                                            }} />
                                    </Box>
                                    <Box
                                        className={`mx-auto divider-horizontal divider-light`}
                                        ms={{
                                            width: '85%',
                                            opacity: '0.5'
                                        }} />
                                    <Box
                                        className={`third d-none`}
                                        ms={{
                                            height: '92px'
                                        }}>
                                        <Box
                                            className={`d-flex justify-content-between align-item-center px-xxl py-lg`}>
                                            <Box>
                                                <Typography
                                                    className={`d-block text-center text-white`}
                                                    component='small'>
                                                    شارژ استفاده شده توسط اعضا
                                                </Typography>
                                                <Typography
                                                    className={`d-block text-bold text-center text-white`}
                                                    component='small'>
                                                    {balance !== 'loading' && `${(Math.floor(balance.members.usedPrice) / 10).toLocaleString()} تومان`}
                                                    {balance === 'loading' &&
                                                        <Image
                                                            className={`d-inline`}
                                                            src={LoadingCustomSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                    }
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography
                                                    className={`d-block text-center text-white`}
                                                    component='small'>
                                                    شارژ باقی‌مانده
                                                </Typography>
                                                <Typography
                                                    className={`d-block text-bold text-center text-white`}
                                                    component='small'>
                                                    {balance !== 'loading' && `${(Math.floor(balance.members.balancePrice) / 10).toLocaleString()} تومان`}
                                                    {balance === 'loading' &&
                                                        <Image
                                                            className={`d-inline`}
                                                            src={LoadingCustomSVG}
                                                            ms={{
                                                                width: '20px',
                                                                height: '20px'
                                                            }} />
                                                    }
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box
                                        className={`w-100 p-md border-solid border-light rounded-md rounded-top-left-0 rounded-top-right-0`}
                                        ms={{
                                            gap: '8px',
                                            backgroundColor: 'var(--white)',
                                            '@media(max-width:576px)': {
                                                right: '0.75rem'
                                            }
                                        }}>
                                        <Link
                                            to='/user/member'>
                                            <Typography
                                                className={`w-100 text-center text-primary border-solid border-primary rounded-sm`}
                                                ms={{
                                                    height: '32px',
                                                    lineHeight: '32px',
                                                    transition: '0.5s',
                                                    '&:hover': {
                                                        backgroundColor: 'var(--blue-ultra-light)'
                                                    }
                                                }}>
                                                مشاهده گزارش اعضا
                                            </Typography>
                                        </Link>
                                    </Box>
                                </Box>
                            </Grid.Item>
                        </React.Fragment>
                    }
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );

}

export default Banner;